import IconButton from 'apollo-react/components/IconButton';
import DeleteIcon from 'apollo-react-icons/Trash';
import React, { useState } from 'react';

import DeleteConfirmationModal from '../../../../../components/DeleteConfirmationModal';
import { useTranslation } from '../../../../../custom-hooks/useTranslation';
import {
  getDeleteRowParams,
  getInstanceName,
  getInstanceTypeLabel,
  getIsDeleteButtonShown,
} from '../../../../utils/entity-designer.utils';

const ActionCell = ({ row }) => {
  const translateString = useTranslation();

  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false);

  const isDeleteButtonShown = getIsDeleteButtonShown(row);

  const handleConfirmDelete = () => {
    const params = getDeleteRowParams(row);

    setIsDeleteModalOpened(false);
    row.deleteRow(params);
  };

  const instanceName = getInstanceName(row);
  const instanceTypeLabel = getInstanceTypeLabel(row.fieldTableControlType);

  const deleteConfirmMessage = (
    <>
      {translateString('Do you really want to delete')} {instanceTypeLabel} <b>{instanceName}</b>
      {'?'}
    </>
  );

  return (
    isDeleteButtonShown && (
      <>
        <IconButton size="small" onClick={() => setIsDeleteModalOpened(true)}>
          <DeleteIcon />
        </IconButton>
        <DeleteConfirmationModal
          message={deleteConfirmMessage}
          open={isDeleteModalOpened}
          onClose={() => setIsDeleteModalOpened(false)}
          onDeleteConfirm={handleConfirmDelete}
        />
      </>
    )
  );
};

export default ActionCell;
